import React, { Fragment } from 'react';
import { Form, InputNumber } from 'antd';

const VehicleWeight = ({ form, disabled }) => {
  const { getFieldDecorator } = form;
  return (
    <Fragment>
      <span className="label">Масса без нагрузки, кг:</span>
      <Form.Item>
        {getFieldDecorator('vehicleWeight')(
          <InputNumber
            min={1}
            max={99999}
            maxLength={5}
            placeholder="Укажите"
            className="smallInput"
            disabled={disabled}
          />
        )}
      </Form.Item>
    </Fragment>
  );
};

export default VehicleWeight;
